import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AdminLayout } from "./components/AdminLayout";
import { applyBrand } from "./lib/brand";
import { CatalogPage } from "./pages/admin/CatalogPage";
import { NewQuote } from "./pages/admin/NewQuote";
import { QuoteList } from "./pages/admin/QuoteList";
import { QuotePage } from "./pages/admin/QuotePage";
import { ClientQuote } from "./pages/portal/ClientQuote";
import { Landing } from "./pages/portal/Landing";
import { MyQuotes } from "./pages/portal/MyQuotes";
import { RedeemLink } from "./pages/portal/RedeemLink";
import "./theme.css";

applyBrand();

function Admin({ children }: { children: React.ReactNode }) {
  return <AdminLayout>{children}</AdminLayout>;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/acceso" element={<RedeemLink kind="magic" />} />
        <Route path="/ver" element={<RedeemLink kind="quote" />} />
        <Route path="/cotizaciones" element={<MyQuotes />} />
        <Route path="/cotizaciones/:id" element={<ClientQuote />} />
        <Route path="/admin" element={<Admin><QuoteList /></Admin>} />
        <Route path="/admin/quotes/new" element={<Admin><NewQuote /></Admin>} />
        <Route path="/admin/quotes/:id" element={<Admin><QuotePage /></Admin>} />
        <Route path="/admin/catalog" element={<Admin><CatalogPage /></Admin>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
